const { includesDocumentRootSelector } = require('./island-root-selector');

/** rp-ui rem tokens assume a 10px root; webstore html is 16px. Rem values are scaled below. */
const RP_UI_ROOT_FONT_SIZE_PX = 10;
const WEBSTORE_ROOT_FONT_SIZE_PX = 16;
const REM_SCALE = RP_UI_ROOT_FONT_SIZE_PX / WEBSTORE_ROOT_FONT_SIZE_PX;

/**
 * @param {number} rem
 * @returns {number}
 */
function scaleRpUiRemToWebstoreRem(rem) {
	return rem * REM_SCALE;
}

/**
 * @param {number} rem
 * @returns {string}
 */
function formatScaledRemValue(rem) {
	return `${parseFloat(rem.toFixed(4))}rem`;
}

/**
 * @param {string} value
 * @returns {string}
 */
function convertRemValuesForWebstoreRoot(value) {
	return value.replace(/(-?\d*\.?\d+)rem\b/g, (match, num) => {
		const rem = parseFloat(num);
		const scaledRem = scaleRpUiRemToWebstoreRem(rem);

		if (Math.abs(scaledRem - rem) < 1e-6) {
			return match;
		}

		return formatScaledRemValue(scaledRem);
	});
}

/**
 * rp-ui :root sets font-size: 10px for historical rem math. Rem scaling targets webstore's 16px
 * html root instead; keeping 10px on the island wrapper only shrinks inherited text.
 *
 * @param {import('postcss').Rule} rule
 * @param {string[]} originalSelectors
 * @returns {void}
 */
function stripRpUiHistoricalRootFontSize(rule, originalSelectors) {
	if (!includesDocumentRootSelector(originalSelectors)) {
		return;
	}

	rule.walkDecls((decl) => {
		if (decl.prop === 'font-size' && decl.value.trim() === '10px') {
			decl.remove();
		}
	});
}

/**
 * @param {import('postcss').Rule} rule
 * @returns {void}
 */
function scaleRemValuesInRule(rule) {
	rule.walkDecls((decl) => {
		decl.value = convertRemValuesForWebstoreRoot(decl.value);
	});
}

/**
 * Scales rp-ui rem decl values for webstore's html root and strips legacy :root font-size: 10px.
 *
 * @param {import('postcss').Rule} rule
 * @param {string[]} originalSelectors
 * @param {{ scaleRem?: boolean }} [options]
 * @returns {void}
 */
function applyWebstoreRemScalingToRule(rule, originalSelectors, options = {}) {
	const shouldScaleRem = options.scaleRem !== false;

	if (shouldScaleRem) {
		scaleRemValuesInRule(rule);
	}

	stripRpUiHistoricalRootFontSize(rule, originalSelectors);
}

module.exports = {
	applyWebstoreRemScalingToRule,
	convertRemValuesForWebstoreRoot,
	scaleRpUiRemToWebstoreRem,
	scaleRemValuesInRule,
	stripRpUiHistoricalRootFontSize,
};
